import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from '../client';
import { IAdminGetCompanyReportsRequest, IAdminGetCompanyReportsResponse } from '@svitlofour/types';
import { version } from '../client/constants';

export const reportsApi = createApi({
  reducerPath: 'reportsApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (build) => ({
    getReports: build.query<IAdminGetCompanyReportsResponse, IAdminGetCompanyReportsRequest>({
      query: (params) => ({
        url: `${version}/company-reports`,
        params
      })
    }),
  })
});

export const { useGetReportsQuery } = reportsApi;
